import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import ApiCredentialService from "services/ApiCredentialService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getApiCredential = createAsyncThunk(
  "apiCredential/getCredential",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ApiCredentialService.getApiCredential(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertApiCredential = createAsyncThunk(
  "apiCredential/upsert",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, showNotification = true } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.showNotification;

      const response = await ApiCredentialService.upsert(payload);

      if (onSuccess) onSuccess(response);

      if (showNotification) {
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title")
        );
      }

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  apiCredentialData: {},
};

export const apiCredentialSlice = createSlice({
  name: "apiCredential",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApiCredential.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApiCredential.fulfilled, (state, action) => {
        state.loading = false;
        state.apiCredentialData = action.payload;
      })
      .addCase(getApiCredential.rejected, (state) => {
        state.loading = false;
      })

      .addCase(upsertApiCredential.pending, (state) => {
        state.loading = true;
      })
      .addCase(upsertApiCredential.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(upsertApiCredential.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = apiCredentialSlice.actions;

export default apiCredentialSlice.reducer;
